import { render, staticRenderFns } from "./ProductOrder.vue?vue&type=template&id=6670570b&scoped=true"
import script from "./ProductOrder.vue?vue&type=script&lang=js"
export * from "./ProductOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6670570b",
  null
  
)

export default component.exports